module.exports = __webpack_public_path__ + "img/menu_bg.b979e0ac.webp";